import { __rest } from "tslib";
import React from 'react';
import FadeInOut from "../FadeInOut";
const FadeSwap = (_a) => {
    var { flag, placeholder, children } = _a, props = __rest(_a, ["flag", "placeholder", "children"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(FadeInOut, Object.assign({ isVisible: flag }, props), placeholder),
        React.createElement(FadeInOut, Object.assign({ isVisible: !flag, isDelayed: true }, props), children)));
};
export default FadeSwap;
//# sourceMappingURL=FadeSwap.js.map